export const SERVER = 'https://fecavolley-dev.cybexai-server.com/api/v1/'